import { createFileRoute } from "@tanstack/react-router";

import { StuckVisitsPage } from "@/features/administration/pages";

/** After how long a visit that does not move counts as stuck. */
export const Route = createFileRoute("/_app/settings/stuck-visits")({
  component: StuckVisitsPage,
});
